import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { Spinner } from '../spinner/spinner'
import { Slot } from '../utilities'
import styles from './chat-message.module.scss'
import { ChatMessageContent } from './chat-message-content'
import { useChatMessageContext } from './context'

export type ChatMessageBodyElement = HTMLDivElement
export type ChatMessageBodyProps = HTMLAttributes<ChatMessageBodyElement> & {
  asChild?: boolean
}

export const ChatMessageBody = forwardRef<ChatMessageBodyElement, ChatMessageBodyProps>(
  function ChatMessageBody(props, forwardedRef) {
    const { children, className, asChild, ...rest } = props
    const { loading } = useChatMessageContext()
    const classes = classNames(
      styles.body,
      {
        [styles.loading]: loading,
      },
      className
    )

    const Component = asChild ? Slot : 'div'

    return (
      <Component {...rest} className={classes} ref={forwardedRef}>
        {loading ? (
          <ChatMessageContent>
            <Spinner size="sm" />
          </ChatMessageContent>
        ) : (
          children
        )}
      </Component>
    )
  }
)
